import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

import FAQ from 'views/GuaranteePage/FAQ';
import TrustSection from 'components/Trust';
import Hero from 'views/GuaranteePage/Hero';
import BookingIsBetter from 'views/GuaranteePage/BookingIsBetter';
import BookingBenefits from 'views/GuaranteePage/BookingBenefits';
import { trackEvent } from 'state/modules/analytics';
import { FAQ_VIEWED, LEARN_MORE } from 'analytics/constants';
import { useDispatch } from 'react-redux';

const TrustSectionStyledBottomBackground = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: -60,
  width: '100%',
  height: 969,
  backgroundImage: "url('images-next/trust-section/trust-section-background-mobile.svg')",
  [theme.breakpoints.up('md')]: {
    top: 0,
    height: 745,
    backgroundImage: "url('images-next/trust-section/trust-section-background-tablet.svg')",
  },
  [theme.breakpoints.up('lg')]: {
    top: 52,
    backgroundImage: "url('images-next/trust-section/trust-section-background-desktop.svg')",
  },
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'top center',
}));

const GuaranteePageView = ({ faqEntries }) => {
  const dispatch = useDispatch();
  const trackFaqView = (faqEntry) => {
    dispatch(
      trackEvent(FAQ_VIEWED, {
        clickTarget: LEARN_MORE,
        faqEntry: faqEntry.question,
        faqCategory: faqEntry.category,
        faqGroup: faqEntry.group,
      })
    );
  };

  return (
    <>
      <Hero />
      <BookingIsBetter />
      <BookingBenefits />
      <FAQ faqEntries={faqEntries} onViewed={trackFaqView} />
      <TrustSection
        title="Party Hosts Trust The Bash With Their Special Moments"
        leftContent={<TrustSectionStyledBottomBackground />}
        sx={{
          overflow: 'hidden',
          position: 'relative',
          pt: 13,
          paddingBottom: { xs: 17, md: 12 },
        }}
      />
    </>
  );
};

GuaranteePageView.propTypes = {
  faqEntries: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
      answer: PropTypes.string.isRequired,
      question: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default GuaranteePageView;
